import { Controller } from "@hotwired/stimulus"

// Generic collapsible toggle (sidebar submenus, accordions).
export default class extends Controller {
  static targets = ["panel", "icon"]

  toggle() {
    const isOpen = !this.panelTarget.classList.contains("hidden")
    this.panelTarget.classList.toggle("hidden", isOpen)
    this.iconTarget?.classList.toggle("rotate-180", !isOpen)
  }
}
